let yearOfEntryCalculator = {};

(function (yearOfEntryCalculatorApp) {
    const gradeAgeMapper = [
        { age: 4, grade: "Pre-Kindergarten" },
        { age: 5, grade: "Kindergarten" },
        { age: 6, grade: "Year 1" },
        { age: 7, grade: "Year 2" },
        { age: 8, grade: "Year 3" },
        { age: 9, grade: "Year 4" },
        { age: 10, grade: "Year 5" },
        { age: 11, grade: "Year 6" },
        { age: 12, grade: "Year 7" },
        { age: 13, grade: "Year 8" },
        { age: 14, grade: "Year 9" },
        { age: 15, grade: "Year 10" },
        { age: 16, grade: "Year 11" },
        { age: 17, grade: "Year 12" }
    ];

    function generateYearList() {
        const isChecked = $('input[name="alreadyInSchool"]').is(':checked');
        const birthMonth = parseInt($('#MonthOfBirthday').val()) || 0;
        const birthYear = parseInt($('#YearOfBirthday').val()) || 0;

        const currentYear = new Date().getFullYear();
        let results = [];
        if (birthMonth > 0 && birthYear > 0) {
            if ((isChecked && birthMonth < 8) || (!isChecked && birthMonth < 4)) {
                gradeAgeMapper.forEach(function (v, i) {
                        if (((isChecked && v.age >= 6) || (!isChecked)) && v.age + birthYear >= currentYear) {
                            results.push({ grade: v.grade, year: v.age + birthYear });
                        }
                    }
                );
            } else {
                gradeAgeMapper.forEach(function (v, i) {
                        if (((isChecked && v.age >= 6) || (!isChecked)) && v.age + birthYear + 1 >= currentYear) {
                            results.push({ grade: v.grade, year: v.age + birthYear + 1 });
                        }
                    }
                );
            }

            renderResults(results);
        }
    }

    function renderResults(array) {
        let html = [];
        array.forEach(function (v, i) {
                html.push("<tr><td class='grade'>" + v.grade + "</td><td class='year'>" + v.year + "</td></tr>");

            }
        );

        if (array.length > 0) {
            $('table').removeClass('hide');
        }

        $('.js-results').html(html.join(''));
    }

    $(document).ready(function () {
        $(".js-toggle-entry-calculator").click(function (e) {
            e.preventDefault();
            $(this).toggleClass("is-active");
            $(this).parents(".entry-calculator").find(".entry-calculator__container").fadeToggle(250);
        });

        $(".entry-calculator__form-submit .button").click(function (e) {
            e.preventDefault();
            $(this).parents(".entry-calculator").find(".entry-calculator__result").fadeIn(250);
            generateYearList();
        });

        $('input[name="alreadyInSchool"], select').change(generateYearList);
    });

})(yearOfEntryCalculator);
